// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .child {
  display: flex;
  flex-direction: column;
  height: 100%; /* Takes full height of the container */
}
::ng-deep .dynamic-content {
  flex: 1; /* Takes remaining space, making it dynamic */
  overflow-y: scroll;
}
::ng-deep .footer {
  height: 58px; /* Fixed height for the footer */
}
::ng-deep table.table-product-list th {
  padding: 1rem 0.25rem 1rem 0.5rem !important;
  font-size: smaller;
  border-width: 1px !important;
}
::ng-deep table.table-product-list td {
  padding: 0.25rem 0.5rem !important;
  font-size: smaller;
}
::ng-deep table.table-product-list td a {
  color: var(--primary-light);
  text-decoration: none;
}
::ng-deep table.table-product-list td a:hover {
  color: var(--primary-light);
  text-decoration: underline;
}
::ng-deep table.table-product-list td a:visited {
  color: var(--primary-light);
}
::ng-deep table.table-product-list td:first-child img {
  max-height: 120px; /* Maximum height of 100px */
  max-width: 120px; /* Maximum width of 100px */
  width: auto; /* Maintain aspect ratio */
  height: auto; /* Maintain aspect ratio */
}
::ng-deep table.table-product-list td .SOLDOUT {
  color: red !important;
}
::ng-deep table.table-product-list td .LOWSTOCK {
  color: #ffc107 !important; /* Bright yellow, visible on white background */
}
::ng-deep table.table-product-list td .INSTOCK {
  color: green !important;
}`, "",{"version":3,"sources":["webpack://./src/app/secure/dashboard/rfqs/quotation/product-list/product-list-overlay.component.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,sBAAA;EACA,YAAA,EAAA,uCAAA;AAAF;AAGC;EACC,OAAA,EAAA,6CAAA;EACA,kBAAA;AADF;AAIC;EACC,YAAA,EAAA,gCAAA;AAFF;AAOG;EACC,4CAAA;EACA,kBAAA;EACA,4BAAA;AALJ;AAQG;EACC,kCAAA;EACA,kBAAA;AANJ;AAQI;EACC,2BAAA;EACA,qBAAA;AANL;AAQK;EACC,2BAAA;EACA,0BAAA;AANN;AASK;EACC,2BAAA;AAPN;AAWI;EACC,iBAAA,EAAA,4BAAA;EACA,gBAAA,EAAA,2BAAA;EACA,WAAA,EAAA,0BAAA;EACA,YAAA,EAAA,0BAAA;AATL;AAYI;EACC,qBAAA;AAVL;AAYI;EACC,yBAAA,EAAA,+CAAA;AAVL;AAYI;EACC,uBAAA;AAVL","sourcesContent":["::ng-deep {\n\t.child {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\theight: 100%; /* Takes full height of the container */\n\t}\n\n\t.dynamic-content {\n\t\tflex: 1; /* Takes remaining space, making it dynamic */\n\t\toverflow-y: scroll;\n\t}\n\n\t.footer {\n\t\theight: 58px; /* Fixed height for the footer */\n\t}\n\n\ttable {\n\t\t&.table-product-list {\n\t\t\tth {\n\t\t\t\tpadding: 1rem 0.25rem 1rem 0.5rem !important;\n\t\t\t\tfont-size: smaller;\n\t\t\t\tborder-width: 1px !important;\n\t\t\t}\n\n\t\t\ttd {\n\t\t\t\tpadding: 0.25rem 0.5rem !important;\n\t\t\t\tfont-size: smaller;\n\n\t\t\t\ta {\n\t\t\t\t\tcolor: var(--primary-light);\n\t\t\t\t\ttext-decoration: none;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: var(--primary-light);\n\t\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t\t}\n\n\t\t\t\t\t&:visited {\n\t\t\t\t\t\tcolor: var(--primary-light);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&:first-child img {\n\t\t\t\t\tmax-height: 120px; /* Maximum height of 100px */\n\t\t\t\t\tmax-width: 120px; /* Maximum width of 100px */\n\t\t\t\t\twidth: auto; /* Maintain aspect ratio */\n\t\t\t\t\theight: auto; /* Maintain aspect ratio */\n\t\t\t\t}\n\n\t\t\t\t.SOLDOUT {\n\t\t\t\t\tcolor: red !important;\n\t\t\t\t}\n\t\t\t\t.LOWSTOCK {\n\t\t\t\t\tcolor: #ffc107 !important; /* Bright yellow, visible on white background */\n\t\t\t\t}\n\t\t\t\t.INSTOCK {\n\t\t\t\t\tcolor: green !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
